/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { AlarmFeature } from "./types";

export default function Alarm(feature: AlarmFeature) {
  let toggleAction = feature.actions && feature.actions.toggle;

  this.canToggleAlarm = () => toggleAction != null;

  this.toggleAlarm = () => {
    if (this.canToggleAlarm) {
      return this.executeDeviceAction(toggleAction);
    } else {
      return Promise.reject(
        new Error("Can't toggle an alarm with no toggle action")
      );
    }
  };

  this.isOn = () => feature.status === "on";

  return { status: feature.status };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/alarm.js